"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineSpecialColorForSegment = void 0;
var config = __importStar(require("./config.ts"));
/**
 * Determines if a segment should use a special color based on flower properties and chance.
 * @param workingPalette The palette the flower is currently working with.
 * @param isUserClickFlower True if the flower was generated by a user click.
 * @param isMockUserFlower True if the flower was generated by a mock user.
 * @param hasEffectivePalette True if the flower has a specific `effectivePalette` (e.g., for overlap or click).
 * @returns The chosen special color string, or null if no special color is chosen by preference.
 */
function determineSpecialColorForSegment(workingPalette, isUserClickFlower, isMockUserFlower, hasEffectivePalette) {
    var preferenceChance = 0.0;
    var applyPreferenceLogic = false;
    if (isUserClickFlower) {
        preferenceChance = Math.min(1.0, config.BASE_SPECIAL_COLOR_PREFERENCE_CHANCE * 2);
        applyPreferenceLogic = true;
    }
    else if (isMockUserFlower || hasEffectivePalette) {
        // Mock flowers OR flowers with a special effectivePalette (like overlap-intensified ones)
        preferenceChance = config.BASE_SPECIAL_COLOR_PREFERENCE_CHANCE;
        applyPreferenceLogic = true;
    }
    if (applyPreferenceLogic) {
        var potentialSpecialColorsInPalette = [
            config.SPECIAL_COLOR,
        ].filter(function (sc) { return workingPalette.includes(sc); });
        if (potentialSpecialColorsInPalette.length > 0 &&
            Math.random() < preferenceChance) {
            return potentialSpecialColorsInPalette[Math.floor(Math.random() * potentialSpecialColorsInPalette.length)];
        }
    }
    return null; // No special color chosen by preference
}
exports.determineSpecialColorForSegment = determineSpecialColorForSegment;
